/**
 * Comic reaction of the boss to a decoy hit (GDD §9.1, §13.4, issue #96): the "Es harina" bubble stays for 3 s of
 * simulation (proposal) from the hit, so a pause freezes it, and has at most 8 words.
 */
export const REACTION_SECONDS = 3;
export const REACTION_MAX_WORDS = 8;

export function reactionVisible(coreTick: number, lastHitTick: number | null, ticksPerSecond: number): boolean {
  return lastHitTick !== null && coreTick - lastHitTick < REACTION_SECONDS * ticksPerSecond;
}

export const wordCount = (text: string): number => text.split(/\s+/).filter(Boolean).length;
